// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"lucide lucide-arrow-big-down-dash-icon lucide-arrow-big-down-dash\"><path d=\"M15 5H9\"/><path d=\"M15 9v3h4l-7 7-7-7h4V9z\"/></svg>";
// Exports
module.exports = code;